export const canUseCoupon = (input: { hasCouponAvailable?: boolean; appliedCouponCode?: string | null }): boolean =>
  Boolean(input.hasCouponAvailable || input.appliedCouponCode);
